import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import { newUserRoleCreation } from "./userRoleCreateAction";
import { newRolePermissionCreation } from "../userRolePermission/rolepermissionAction"
import { useDispatch, useSelector } from "react-redux";
import * as bootstrap from 'bootstrap';
import { useForm } from "react-hook-form";
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import { useParams,useNavigate } from 'react-router-dom';
import { getAllMenu } from '../menu/menuAction';
import '../userRolePermission/rolepermission.css';
import Swal from "sweetalert2";
import { FaArrowCircleLeft, FaUsers } from 'react-icons/fa';
import Button1 from '@mui/material/Button';


const CreateUserRole = () => {

  const initialState = {
    userrole: "",
    status: "",
  
  }
   
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [newUserRole, setNewUserRole] = useState(initialState);

  const [alertStatus, setAlertStatus] = useState('');
  const [menus, setMenus] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [expanded, setExpanded] = useState([]);
  const [checked, setChecked] = useState([]);
  const [selectAll, setSelectAll] = useState(false);


  const { register, handleSubmit, formState: { errors } } = useForm();

  const { id } = useParams();
  const { menuisLoading, menu } = useSelector((state) => state.menuList);

 const { isLoading, status, message, userroledata } = useSelector((state) => state.userRoleCreate);

  useEffect(() => { }, [newUserRole]);
  
  useEffect(() => {
    if (menu.length > 0) {
      const initialTreeData = mapMenuDataToTree(menu);
      setTreeData(initialTreeData);
    }
    setMenus(menu);
  }, [menu]);
  

  useEffect(() => {
    dispatch(getAllMenu());
  }, []);


  function mapMenuDataToTree(menuItems) {
  return menuItems
    .filter((menuItem) => menuItem.parent_id === 0)
    .map((menuItem) => {
      const childNodes = menuItems.filter(
        (childItem) => childItem.parent_id === menuItem.id
      );
      const children = childNodes.map((childNode) => {
        const isChildChecked = checked.includes(childNode.id);
        const isChildPartial = isChildChecked && !isAllChildrenChecked(childNode);
        return {
          id: childNode.id,
          value: childNode.label,
          label: childNode.label,
          children: mapMenuDataToTree(
            menuItems.filter((childItem) => childItem.parent_id === childNode.id)
          ),
          status: isChildChecked ? 1 : 0,
          checked: isChildChecked,
          indeterminate: isChildPartial,
        };
      });

      const isMainChecked = checked.includes(menuItem.id);
      const isMainPartial = isMainChecked && !isAllChildrenChecked(menuItem);

      return {
        id: menuItem.id,
        value: menuItem.label,
        label: menuItem.label,
        children: children.length > 0 ? children : null,
        status: isMainChecked ? 1 : 0,
        checked: isMainChecked,
        indeterminate: isMainPartial,
      };
    });
}

  
  function isAllChildrenChecked(node) {
    if (!node.children) {
      return checked.includes(node.id);
    }
  
    const childrenIds = node.children.map((child) => child.id);
    const checkedChildren = childrenIds.filter((id) => checked.includes(id));
  
    return childrenIds.length === checkedChildren.length;
  }
  
  
  const handleCheckAll = () => {
    const updatedTreeData = toggleAllNodeStatus(treeData, 1);
    setTreeData(updatedTreeData);
  };

  const handleUncheckAll = () => {
    const updatedTreeData = toggleAllNodeStatus(treeData, 0);
    setTreeData(updatedTreeData);
  };
  

  function toggleAllNodeStatus(nodes, status) {
    return nodes.map((node) => {
      const updatedNode = {
        ...node,
        status,
        checked: status === 1,
        indeterminate: false,
      };
  
      if (node.children) {
        updatedNode.children = toggleAllNodeStatus(node.children, status);
      }
  
      return updatedNode;
    });
  }

  const handleOnChange = e => {
    const name = e.target.name;
    const value = e.target.value;
     
    setNewUserRole({ ...newUserRole, [name]: value });

    };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
  
    const { userrole, status } = newUserRole;
    const newUserCreation1 = {
      userrole,
      status,
    };
  
    try {
      const response = await dispatch(newUserRoleCreation(newUserCreation1));
      const userRoleId = response?.result?.id;
  
      const rolePermissions = treeData.reduce((permissions, menuItem) => {
        const permission = {
          userroleid: userRoleId,
          menuid: menuItem.id,
          status: menuItem.status, // Use the status property of the node
        };
        permissions.push(permission);
        if (menuItem.children) {
          menuItem.children.forEach((childNode) => {
            const childPermission = {
              userroleid: userRoleId,
              menuid: childNode.id,
              status: childNode.status, // Use the status property of the node
            };
            permissions.push(childPermission);
          });
        }
        return permissions;
      }, []);
  
      const rolePermissionPromises = rolePermissions.map((permission) => {
        console.log(permission)
        return dispatch(newRolePermissionCreation(permission));
      });
  
      await Promise.all(rolePermissionPromises);
  
      // Handle success or perform any necessary actions
      Swal.fire('Success', 'User role created successfully', 'success');
      navigate('/allRoles')
  
      e.target.reset();
    } catch (error) {
      // Handle errors
      console.log("Error:", error);
      // Display an error message or perform any necessary actions
    }
  };
  const canSave = Boolean(newUserRole.userrole) && Boolean(newUserRole.status)


  function handleCheckboxChange(nodeId) {
    const updatedTreeData = toggleNodeStatus(treeData, nodeId);
    setTreeData(updatedTreeData);
  }
  
  
  function updateDescendants(nodes, parentNode) {
    if (!parentNode.children) {
      return parentNode;
    }
  
    const updatedChildren = parentNode.children.map((childNode) => {
      const updatedChildNode = {
        ...childNode,
        checked: parentNode.checked,
        indeterminate: false,
        status: parentNode.checked ? 1 : 0,
      };
      return updateDescendants(childNode.children, updatedChildNode);
    });
  
    return {
      ...parentNode,
      children: updatedChildren,
    };
  }

  
  function toggleNodeStatus(nodes, targetNode) {
    const updatedNodes = nodes.map((node) => {
      if (node.id === targetNode.id) {
        const newChecked = !targetNode.checked;
        const isAllChildrenChecked = node.children?.every((child) => child.checked);
        const isSomeChildrenChecked = node.children?.some((child) => child.checked || child.indeterminate);
        const indeterminate = !isAllChildrenChecked && isSomeChildrenChecked;
  
        const updatedNode = {
          ...targetNode,
          checked: newChecked,
          indeterminate: indeterminate,
          status: indeterminate ? 1 : (newChecked ? 1 : 0),
        };
        return updateDescendants(nodes, updatedNode);
      }
  
      if (node.children) {
        const updatedChildren = toggleNodeStatus(node.children, targetNode);
        const isAllChildrenChecked = updatedChildren.every((child) => child.checked);
        const isSomeChildrenChecked = updatedChildren.some((child) => child.checked || child.indeterminate);
        const indeterminate = !isAllChildrenChecked && isSomeChildrenChecked;
  
        return {
          ...node,
          children: updatedChildren,
          indeterminate: indeterminate,
          status: indeterminate ? 1 : (node.checked ? 1 : 0),
        };
      }
  
      return node;
    });
  
    return updateAncestors(updatedNodes, targetNode);
  }
  
  
  

  function updateAncestors(nodes, targetNode) {
    const parent = findParentNode(nodes, targetNode);
  
    if (parent) {
      const allSiblings = parent.children || [];
      const checkedSiblings = allSiblings.filter((sibling) => sibling.checked || sibling.indeterminate);
  
      const newParent = {
        ...parent,
        checked: checkedSiblings.length === allSiblings.length,
        indeterminate: checkedSiblings.length > 0 && checkedSiblings.length !== allSiblings.length,
      };
  
      const updatedNodes = nodes.map((node) => {
        if (node.id === parent.id) {
          return newParent;
        }
  
        if (node.children) {
          return {
            ...node,
            children: toggleNodeStatus(node.children, targetNode),
          };
        }
  
        return node;
      });
  
      return updateAncestors(updatedNodes, newParent);
    }
  
    return nodes;
  }
  
  function findParentNode(nodes, targetNode) {
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
  
      if (node.children) {
        if (node.children.some((child) => child.id === targetNode.id)) {
          return node;
        }
  
        const parentNode = findParentNode(node.children, targetNode);
        if (parentNode) {
          return parentNode;
        }
      }
    }
  
    return null;
  }
  
  function handleExpand(node) {
    const updatedTreeData = toggleNodeExpanded(treeData, node);
    setTreeData(updatedTreeData);
  }
  
  function toggleNodeExpanded(nodes, targetNode) {
    return nodes.map((node) => {
      if (node.id === targetNode.id) {
        return { ...node, expanded: !node.expanded };
      }
  
      if (node.children) {
        return {
          ...node,
          children: toggleNodeExpanded(node.children, targetNode),
        };
      }
  
      return node;
    });
  }

  function renderCheckboxTree(nodes, isChildNode = false) {
    return nodes.map((node) => (
      <div key={node.id} className={isChildNode ? 'child-node' : 'parent-node'}>
        <div onClick={() => handleExpand(node)} className="node-label">
          {!isChildNode && node.children && (
            <i className="parent-icon fa fa-chevron-right"></i>
          )}
          {isChildNode && <div className="spacer" />}
          <Form.Check
            type="checkbox"
            id={`menu-${node.id}`}
            label={node.label}
            checked={node.checked}
            onChange={() => handleCheckboxChange(node)}
            onClick={(e) => e.stopPropagation()}
            className={node.indeterminate ? 'partially-checked' : ''}
          />
        </div>
        {node.children && node.expanded && (
          <div className="child-nodes">
            {renderCheckboxTree(node.children, true)}
          </div>
        )}
      </div>
    ));
  }
  
  
  
  
  
  return (
    <>
      
          <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Create New User Role</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <div><Button1 variant='contained' style={{backgroundColor:'#d1af2b'}} onClick={() => navigate('/allRoles')}><FaArrowCircleLeft className="ml-2 me-2" />Back to User Role List
        </Button1></div>
   
                        </Row>
                        <br />
            <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={handleOnSubmit}>

              {/* <Row className="mb-3"> */}
              <Form.Group as={Col} controlId="formGridUsername">
  <Form.Label>User Role</Form.Label>
  <Form.Control
    type="text"
    name="userrole"
    autoComplete="off"
    placeholder="Enter User Role"
    {...register("userrole", { required: true })}
    onChange={handleOnChange}
    style={{ width: "500px" }}
    maxLength={50} // Set the maximum character limit here (e.g., 50 characters)
  />
</Form.Group>
{errors.userrole && <p>Please check the First Name</p>}

                <Form.Group as={Col} controlId="formGridStatus" className='mt-4' style={{ width: "500px"}}>
                  <Form.Label>Status</Form.Label>
                  <Form.Select required name="status" {...register("status")} onChange={handleOnChange}>
                    
                    <option value="">Choose..</option>
                    <option value="1">Enable</option>
                    <option value="0">Disable</option>
                  </Form.Select>
                </Form.Group>
                <Card className='mt-5'>
                  <div className='mt-3 ms-3 mb-5'>
                  <div>
      <h5>Permission Menu List</h5>
     
        <div className="ms-3 custom-tree">
          <div className="my-container">
            <div className="my-custom-styles">
                 {renderCheckboxTree(treeData)}

            </div>
          </div>
        </div>
    
        <div className='mt-4'>
  <input type="button" className='btn btn-primary btn-sm' value="Check All" onClick={handleCheckAll} style={{ backgroundColor: "#1B3D6D", color: "white" }} />
  <input type="button" className='btn btn-primary btn-sm ms-4' value="Uncheck All" onClick={handleUncheckAll} style={{ backgroundColor: "#1B3D6D", color: "white" }}/>
</div>


    

    </div>
                </div>
                </Card>
              {/* </Row> */}
              <div class="d-grid  col-2 mx-auto">
              <Button
  variant="primary"
  type="submit"
  className="align-middle mt-3"
  style={{
    backgroundColor: "#003893",
    color: "white",
    border: "none",
    padding: "0.5rem 1rem",
    borderRadius: "0.25rem",
    transition: "background-color 0.3s ease",
  }}
  onMouseOver={(e) => (e.target.style.backgroundColor = "#002770")}
  onMouseOut={(e) => (e.target.style.backgroundColor = "#1B3D6D")}
  disabled={!canSave}
>
  Submit
</Button>

              </div>
              {isLoading && (<Spinner variant='info' animation='border' />)}

            </Form>
            </div>
            </div>
            </div>
    </>
  );
}

export default CreateUserRole;